import { displayToast } from "../modules/utils";

export default class SortableColumn {
  constructor(node) {
    this.element = node;
    this.tableHeads = this.element.querySelectorAll("[data-sortable-key]");
    this.keys = [].slice.call(this.tableHeads).map((tableHead) => tableHead.dataset.sortableKey);

    this.initialize();
  }

  initialize() {
    if (!this.getFetchUrl()) {
      displayToast(this.element.dataset.errorMessage);
      return;
    }

    this.tableHeads.forEach((tableHead) => {
      const sortIcon = tableHead.querySelector(".js-sort-icon");

      tableHead.addEventListener("click", () => {
        this.handleSort(tableHead, sortIcon);
      });
    });
  }

  updateClassesAndSetValue(iconElement) {
    let value = "desc";

    if (iconElement.classList.contains("desc")) {
      value = "asc";
      iconElement.classList.remove("desc");
      iconElement.classList.add("asc");
    } else if (iconElement.classList.contains("asc")) {
      value = "";
      iconElement.classList.remove("asc");
    } else {
      iconElement.classList.add("desc");
    }

    return value;
  }

  updateUrl(url, tableHead, value) {
    const updatedUrl = new URL(url, window.location.origin);
    updatedUrl.searchParams.set(tableHead.dataset.sortableKey, value);

    // We remove all other sort keys from the fetch URL
    this.tableHeads.forEach((head) => {
      if (head !== tableHead) {
        head.querySelector(".js-sort-icon")?.classList.remove("asc", "desc");
        updatedUrl.searchParams.delete(head.dataset.sortableKey);
      }
    });

    return updatedUrl;
  }

  handleSort(tableHead, iconElement) {
    const value = this.updateClassesAndSetValue(iconElement);

    this.fetchUrlElement.dataset.url = this.updateUrl(this.fetchUrlElement.dataset.url, tableHead, value);

    const paginationLinks = this.paginationUrlElementWrapper?.querySelectorAll("a");

    if (paginationLinks) {
      paginationLinks.forEach((element) => {
        element.href = this.updateUrl(element.href, tableHead, value);
      });

      this.fetchUrlElement.dispatchEvent(new Event("pagination-link-updated"));
    }
  }

  getFetchUrl() {
    this.fetchUrlElement = document.querySelector(".js-overview-filter-pagination");
    this.paginationUrlElementWrapper = document.querySelector(".js-overview-filter-pagination-element");

    return this.fetchUrlElement;
  }
}
